import * as Yup from 'yup';

export const loginSchema = Yup.object({
  email_address: Yup.string().email().required(),
  password: Yup.string().required('Please enter a password').min(8, 'Password must have at least 8 characters'),
});
